export interface PinsPublicationDisplayRecord {
  platform: string;
  accountId?: string | null;
}

/** Only show publication badges for profiles actually assigned to this material. */
export function assignedPinsPublicationsForPlatform<T extends PinsPublicationDisplayRecord>(
  publications: readonly T[] | null | undefined,
  platform: string,
): T[] {
  return (publications ?? []).filter((publication) => publication.platform === platform && Boolean(publication.accountId));
}
